import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IconsName } from '../../svg-icon';

@Component({
  selector: 'shrd-uic-nav-list-button',
  templateUrl: './nav-list-button.component.html',
  styleUrls: ['./nav-list-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavListButtonComponent implements OnInit {
  @Input() variantType: 'button' | 'text' = 'button';
  @Input() href: string;
  @Input() disabled = false;
  @Input() showIcon = true;
  @Input() iconName = IconsName.ARROW_LEFT;
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() defaultIconColor = false;
  @Input() hideIconOnSelect = true;
  @Input() isSelected = false;
  @Input() convertToTextTypeOnSelected = true;
  @Input() hasTextIndent = true;
  @Input() showTextBold = false;
  @Input() additionalClasses: string;
  @Input() qaId: string;

  @Output() buttonClicked = new EventEmitter<boolean>();

  showButtonType = true;

  ngOnInit(): void {
    this.showButtonType = this.variantType === 'button' && !(this.isSelected && this.convertToTextTypeOnSelected);
  }

  /**
   * called upon interaction with the button
   */
  buttonClick(): void {
    if (this.disabled) {
      return;
    }

    this.isSelected = !this.isSelected;
    this.showButtonType = !(this.isSelected && this.convertToTextTypeOnSelected);
    this.buttonClicked.emit(true);
  }
}
